<template>
    <div>
         <v-dialog
                v-model="proccess"
                persistent
                width="300">
                        <v-card
                        color="primary"
                        dark>
                                <v-card-text>Please wait
                                        <v-progress-linear
                                        indeterminate
                                        color="white"
                                        class="mb-0"
                                        />
                                        
                        </v-card-text>
                </v-card>
        </v-dialog>

    </div>
</template>

<script>
export default {
    data(){
        return {
            proccess:true
        }
    }
    
}
</script>
